import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './Header';
import { SearchProvider } from "./SearchContext";
import HomePage from './pages/HomePage/HomePage';
import PoolPage from './pages/PoolPage/PoolPage';
import HealthCheckPage from './pages/HealthCheckPage/HealthCheckPage';
import LoginPage from './pages/LoginPage/LoginPage';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import DomainsPage from './pages/DomainsPage/DomainsPage';
import NotFound from "./NotFound";


function App() {
    return (
        <Router>
            <Main />
        </Router>
    );
}

function Main() {
    const location = useLocation();   

    const headerRoutes = ["/", "/pool/:poolName", "/domains", "/health-check"];
    const showHeader = headerRoutes.some((route) =>
        matchRoute(route, location.pathname)
    );

    return (
        <div>
            {showHeader && <Header />}
            <div className="max-w-screen-xl mx-auto min-h-full px-4 py-8">
                <SearchProvider>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />

                        <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
                        <Route path="/pool/:poolName" element={<ProtectedRoute><PoolPage /></ProtectedRoute>} />
                        <Route path="/domains" element={<ProtectedRoute><DomainsPage /></ProtectedRoute>} />
                        <Route path="/health-check" element={<ProtectedRoute><HealthCheckPage /></ProtectedRoute>} />

                        {/* Catch-All Route for 404 */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </SearchProvider>
            </div>
        </div>
    );
}

export default App;


function matchRoute(pattern, path) {
    const regex = new RegExp(
        "^" + pattern.replace(/:[^\s/]+/g, "([^/]+)") + "$"
    );
    return regex.test(path);
}
